import { toast } from "react-toastify";
import ServiceWorkerWrapper from "./NewVersionAvailableAlertMessage";

type Config = {
  onUpdate: (registration: ServiceWorkerRegistration) => void;
  onOffline: () => void;
  onOnline: () => void;
};

export const config: Config = {
  onUpdate: (registration) => {
    toast.dismiss();
    toast(<ServiceWorkerWrapper serviceWorkerRegistration={registration} />, {
      position: "bottom-center",
      closeButton: false,
    });
  },
  onOffline: () => {
    toast(
      "Vous êtes hors ligne.",
      {
        position: toast.POSITION.BOTTOM_CENTER,
        theme: "colored",
        type: toast.TYPE.ERROR,
        toastId: "onAndOfflineToast",
        autoClose: 10000,
      }
    );
  },
  onOnline: () => {
    toast("La connexiion est rétablie", {
      position: toast.POSITION.BOTTOM_CENTER,
      theme: "colored",
      type: toast.TYPE.SUCCESS,
      autoClose: 10000,
    });
  },
};
